/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberSearchShowAlbumRequest = {
  id?: number;
  groupId: number;
  perPage?: number | null;
  page?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: MemberSearchShowAlbumRequest.direction | null;
};

export namespace MemberSearchShowAlbumRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
